<template>
  <div class="main relatorios">
    <c-panel title="Relatórios Transporte" titleIcon="far fa-chart-bar">
      <el-form label-position="top">
        <el-row :gutter="10" class="u-mt-10">
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Instituição" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
              <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
              <label class="el-form-item__label">Instituição</label>
              <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Ano (opcional)" key="ano">
              <el-input v-model="filtro.ano" maxlength="4" placeholder="ex: 2026"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Relatório" key="relatorio">
              <el-select v-model="relatorioSelected" placeholder="Selecione" filterable>
                <el-option label="ALUNOS POR ROTA" value="alunos_por_rota"></el-option>
                <el-option label="FREQUÊNCIA DO TRANSPORTE" value="frequencia"></el-option>
                <el-option label="CUSTO POR VEÍCULO" value="custo_por_veiculo"></el-option>
                <el-option label="CONSUMO COMBUSTÍVEL" value="consumo_combustivel"></el-option>
                <el-option label="ROTAS EXECUTADAS" value="rotas_executadas"></el-option>
                <el-option label="MANUTENÇÃO" value="manutencoes"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Rota (opcional)" key="rota_id">
              <el-select v-model="filtro.rota_id" placeholder="pesquisar..." filterable remote clearable :remote-method="searchRota" :loading="loadingRota">
                <el-option v-for="r in rotas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Veículo (opcional)" key="veiculo_id">
              <el-select v-model="filtro.veiculo_id" placeholder="pesquisar..." filterable remote clearable :remote-method="searchVeiculo" :loading="loadingVeiculo">
                <el-option v-for="v in veiculos" :key="v.id" :label="v.placa" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Turno (opcional)" key="turno">
              <el-select v-model="filtro.turno" placeholder="Selecione" clearable>
                <el-option label="MANHÃ" value="manha"></el-option>
                <el-option label="TARDE" value="tarde"></el-option>
                <el-option label="NOITE" value="noite"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data inicial" key="data_inicio">
              <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data final" key="data_fim">
              <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" class="u-text-right u-mt-20">
            <el-button @click="emitPdf()" :loading="loadingButtonPdf" type="primary">PDF</el-button>
            <el-button class="u-ml-10" @click="emitHtml()" :loading="loadingButtonHtml" type="primary">HTML</el-button>
          </el-col>
        </el-row>
      </el-form>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  }
  ,
  data: () => ({
    relatorioSelected: 'alunos_por_rota',
    loadingButtonPdf: false,
    loadingButtonHtml: false,
    loadingRota: false,
    rotas: [],
    loadingVeiculo: false,
    veiculos: [],
    ref: [],
    filtro: {
      instituicao_id: '',
      ano: '',
      rota_id: '',
      veiculo_id: '',
      turno: '',
      data_inicio: '',
      data_fim: ''
    }
  }),
  mounted () {
    if (this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) {
      this.filtro.instituicao_id = this.$store.state.config.instituicao.id
    }
    this.filtro.ano = String((new Date()).getFullYear())
  },
  methods: {
    searchRota (query) {
      if (!query || query.length < 2) { this.rotas = []; return }
      this.loadingRota = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.rotas = JSON.parse(JSON.stringify(res.data)); this.loadingRota = false })
        .catch(e => { this.loadingRota = false; this.$store.commit('throwException', e) })
    },
    searchVeiculo (query) {
      if (!query || query.length < 2) { this.veiculos = []; return }
      this.loadingVeiculo = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/searchByPlaca`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.veiculos = JSON.parse(JSON.stringify(res.data)); this.loadingVeiculo = false })
        .catch(e => { this.loadingVeiculo = false; this.$store.commit('throwException', e) })
    },
    buildRef () {
      const ref = []
      if (this.filtro.instituicao_id) {
        let valor = this.filtro.instituicao_id
        if (this.$refs.instituicao_id && this.$refs.instituicao_id.selected && this.$refs.instituicao_id.selected.label) {
          valor = this.$refs.instituicao_id.selected.label
        } else if (this.$store.state.config.instituicao && this.$store.state.config.instituicao.nome) {
          valor = this.$store.state.config.instituicao.nome
        }
        ref.push({ nome: 'Instituição', valor })
      }
      if (this.filtro.ano) ref.push({ nome: 'Ano', valor: this.filtro.ano })
      if (this.filtro.data_inicio) ref.push({ nome: 'Data inicial', valor: this.filtro.data_inicio })
      if (this.filtro.data_fim) ref.push({ nome: 'Data final', valor: this.filtro.data_fim })
      if (this.filtro.rota_id) {
        const r = this.rotas.find(x => x.id === this.filtro.rota_id)
        ref.push({ nome: 'Rota', valor: r ? r.nome : this.filtro.rota_id })
      }
      if (this.filtro.veiculo_id) {
        const v = this.veiculos.find(x => x.id === this.filtro.veiculo_id)
        ref.push({ nome: 'Veículo', valor: v ? v.placa : this.filtro.veiculo_id })
      }
      if (this.filtro.turno) ref.push({ nome: 'Turno', valor: this.filtro.turno })
      this.ref = ref
    },
    validateFiltro () {
      if (!this.filtro.instituicao_id) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição.', type: 'warning' })
        return false
      }
      return true
    },
    getPdfUrl () {
      if (this.relatorioSelected === 'alunos_por_rota') return '/api/pdf/renderRelatorioTransporteAlunosPorRota/pdf'
      if (this.relatorioSelected === 'frequencia') return '/api/pdf/renderRelatorioTransporteFrequencia/pdf'
      if (this.relatorioSelected === 'custo_por_veiculo') return '/api/pdf/renderRelatorioTransporteCustoPorVeiculo/pdf'
      if (this.relatorioSelected === 'consumo_combustivel') return '/api/pdf/renderRelatorioTransporteConsumoCombustivel/pdf'
      if (this.relatorioSelected === 'rotas_executadas') return '/api/pdf/renderRelatorioTransporteRotasExecutadas/pdf'
      return '/api/pdf/renderRelatorioTransporteManutencoes/pdf'
    },
    getHtmlSlug () {
      if (this.relatorioSelected === 'alunos_por_rota') return 'transporte-alunos-por-rota'
      if (this.relatorioSelected === 'frequencia') return 'transporte-frequencia-transporte'
      if (this.relatorioSelected === 'custo_por_veiculo') return 'transporte-custo-por-veiculo'
      if (this.relatorioSelected === 'consumo_combustivel') return 'transporte-consumo-combustivel'
      if (this.relatorioSelected === 'rotas_executadas') return 'transporte-rotas-executadas'
      return 'transporte-manutencoes'
    },
    emitPdf () {
      if (!this.validateFiltro()) return
      this.buildRef()
      this.loadingButtonPdf = true
      window.eventBus.$emit('print', { url: this.getPdfUrl(), param: { ref: this.ref, filtros: this.filtro } })
      this.loadingButtonPdf = false
    },
    async emitHtml () {
      if (!this.validateFiltro()) return
      this.buildRef()
      this.loadingButtonHtml = true
      try {
        const slug = this.getHtmlSlug()
        const response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/` + slug, { ref: this.ref, filtros: this.filtro }, this.$store.getters.getHeaderAuth)
        window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`)
      } catch (e) {
        window.eventBus.$emit('alert', { msg: 'Erro ao gerar relatório.', type: 'warning' })
      }
      this.loadingButtonHtml = false
    }
  }
}
</script>

